<template>
    <div class="user-lists-modal delete-list-dialog">

        <!-- Shadow -->
        <div class="user-lists-modal__shade" @click="closeModal"></div>

        <!-- Modal -->
        <div class="user-lists-modal__inner" v-if="currentList">

            <!-- Close Modal -->
            <span class="user-lists-modal__close" @click="closeModal">
                <svg class='close'><use xlink:href="#close"></use></svg>
            </span>

            <!-- Header -->
            <h2>Delete List</h2>

            <p>
                Are you sure you want to delete the list {{ currentList.name }}? If other users follow this list, it will no longer be available to them.
            </p>

            <!-- Form -->
            <form method="post" :action="`/${this.currentList.user.username}/lists/${this.currentList.id}`" @submit.prevent="submit">
                <div class="form__button">
                    <button type="submit"
                            :class="{ 'is-submitting': form.isSubmitted }"
                            :disabled="form.isSubmitted"
                            class="button">
                        {{ form.isSubmitted ? 'Deleting' : 'Delete List' }}
                        <svg class='arrow-right-2'><use xlink:href="#arrow-right-2"></use></svg>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import Form from '@/classes/Form'

export default {

    props: ['list'],

    data() {
        return {
            currentList: this.list,
            form: new Form().dontClear()
        }
    },

    created() {

        eventBus.$on('open-delete-list-modal', (list) => {
            this.currentList = list;
            this.openModal();
        });
    },

    methods: {

        submit() {
            this.form.delete(`/${this.currentList.user.username}/lists/${this.currentList.id}`)
                .then(response => {
                    eventBus.$emit('list-deleted', response)
                    this.closeModal()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        openModal(){
            $('.delete-list-dialog').fadeIn()
        },

        closeModal(){
            $('.delete-list-dialog').fadeOut();
        }
    }
}
</script>
